import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IUser, IRole, AppConstants } from '../models';
import { _isNumberValue } from '@angular/cdk/coercion';
import { IPermissionsResponse, IResponse, BaseResponse } from '../models/responses';
import { takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private httpClient: HttpClient) { }

  Store(_user: IUser): Observable<BaseResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${AppConstants.API_URL}api/User/StoreUser`;
    
    return this.httpClient.post<BaseResponse>(url, _user, { headers });
  }

  Update(_user: IUser): Observable<BaseResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${AppConstants.API_URL}api/User/StoreUser`;
    
    return this.httpClient.post<BaseResponse>(url, _user, { headers });
  }

  Get(): Observable<IResponse<IUser[]>> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${AppConstants.API_URL}api/User/GetUsers`;
    
    return this.httpClient.get<IResponse<IUser[]>>(url, { headers });
  }

  GetUser(_id: number): Observable<IResponse<IUser>> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${AppConstants.API_URL}api/User/GetUserById?id=${_id}`;
    
    return this.httpClient.get<IResponse<IUser>>(url, { headers });
  }

  // Falta este endpoint
  GetRole(_userId: string): Observable<IPermissionsResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${AppConstants.API_URL}api/User/GetPermissions?userId=${_userId}`;
    
    return this.httpClient.get<IPermissionsResponse>(url, { headers });
  }

  PutByRole(_UserId: number, _roles: IRole[]): Observable<BaseResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${AppConstants.API_URL}api/Role/StoreRolesByUser`;
    
    return this.httpClient.post<BaseResponse>(url, {
      'UserId': _UserId,
      'Roles': _roles
    }, { headers });
  }

  FlushSession() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    
    const url = `${AppConstants.API_URL}api/User/FlushSession`;
    
    return this.httpClient.get<BaseResponse>(url, { headers });
  }
}
